import { gql } from '@apollo/client';
import { WAREHOUSE_PLANNING_ENTRY_CONFIG_FIELDS, WarehousePlanningEntryConfigType } from '../types/WarehousePlanningEntryConfigTypes';

export const UPDATE_WAREHOUSE_PLANNING_ENTRY_CONFIG = gql`
    mutation UpdateWarehousePlanningEntryConfig($id: ID!, $input: UpdateWarehousePlanningEntryConfigInput!) {
        config: updateWarehousePlanningEntryConfig(id: $id, input: $input) {
            ...WarehousePlanningEntryConfigFields
        }
    }
    ${WAREHOUSE_PLANNING_ENTRY_CONFIG_FIELDS}
`;

export interface UpdateWarehousePlanningEntryConfigInput {
    entryNode?: string;
    isActive?: boolean;
    splitOrderConfig?: number[];
    templateEditStartTime?: string;
    templateEditEndTime?: string;
}

export interface UpdateWarehousePlanningEntryConfigResponse {
    config: WarehousePlanningEntryConfigType;
}

